import OperationDate from '@/module/setup/components/OperationDate';
import { FORMAT_DATEOFF } from '@/module/setup/constants';
import moment from 'moment';
import React, { useMemo } from 'react';

/**
 * Restrict dates step of the service drawer — the dates a service cannot be
 * booked on. Reuses Location's closing-date picker; only the labels and the
 * field it writes to differ.
 */

/**
 * The picker speaks MM/DD/YYYY (same as Location's `dayOffs`), but `tests/{id}`
 * is free to hand back ISO. Parsing an ISO string as MM/DD/YYYY yields an
 * invalid moment, which is what rendered every saved row as "Invalid date", so
 * whatever arrives is normalised before it reaches the calendar.
 */
const toPickerFormat = (value) => {
  if (!value) return null;

  const asPickerFormat = moment(value, FORMAT_DATEOFF, true);
  if (asPickerFormat.isValid()) return asPickerFormat.format(FORMAT_DATEOFF);

  const parsed = moment(value);
  return parsed.isValid() ? parsed.format(FORMAT_DATEOFF) : null;
};

const RestrictDatesStep = ({ formValue, setFormValue }) => {
  const rawRestrictedDates = formValue?.restrictedDates;
  const restrictedDates = useMemo(
    () => (rawRestrictedDates || []).map(toPickerFormat).filter(Boolean),
    [rawRestrictedDates]
  );

  // Clicking a date toggles it: selected dates come back off the calendar and
  // the remove icon in the list calls this with the same date. Writing the
  // normalised list back keeps the whole field in one format once touched.
  const onSelectDate = (value) => {
    const formattedValue = toPickerFormat(value);
    if (!formattedValue) return;

    const foundIndex = restrictedDates.findIndex((d) => d === formattedValue);
    const newRestrictedDates =
      foundIndex < 0
        ? [...restrictedDates, formattedValue]
        : restrictedDates.filter((_, index) => index !== foundIndex);

    setFormValue({ ...formValue, restrictedDates: newRestrictedDates });
  };

  return (
    <OperationDate
      selectedDates={restrictedDates}
      onSelectDate={onSelectDate}
      title="Restrict date"
      listTitle="Restrict dates"
    />
  );
};

export default RestrictDatesStep;
